/* Copyright 2016-2022
   Kabandy
   Author: Cedric Hoarau
 */

import { ITime, ITimeSerialized } from ".";

export module AccessRoleDataModel {
    export enum EErrorMsg {
        Update = "Can't update role"
    }

    export enum EUpdateErrorReason {
        RoleNotFound = "Role not found"
    }

    export enum ERoleScope {
        Contract = "contract",
        Project = "project"
    }

    export enum EPermissionType {
        Board = "board",
        Modelfile = "modelfile",
        Modelgroup = "modelgroup",
        Folder = "folder",
        User = "user"
    }

    export enum EDefaultRoleId {
        ContractRole0 = "contract-default-0",
        ProjectRole0 = "project-default-0",
        ProjectRole1 = "project-default-1"
    }

    export const EBoardPermissionFlags = {
        None: 0,
        Create: 1 << 0,
        Delete: 1 << 1,
        Duplicate: 1 << 2,
        Rename: 1 << 3,
        Lock: 1 << 4,
        Unlock: 1 << 5
    };

    export const EFolderPermissionFlags = {
        None: 0,
        Create: 1 << 0,
        Delete: 1 << 1,
        Duplicate: 1 << 2,
        Rename: 1 << 3
    };

    export const EModelfilePermissionFlags = {
        None: 0,
        Create: 1 << 0,
        Delete: 1 << 1,
        Update: 1 << 2,
        DownloadLatestVersion: 1 << 3,
        DownloadAnyVersion: 1 << 4
    };

    export const EModelgroupPermissionFlags = {
        None: 0,
        Create: 1 << 0,
        Delete: 1 << 1,
        Rename: 1 << 3
    };

    export interface IRole {
        id: string;
        contractId: string;
        scope: typeof ERoleScope[keyof typeof ERoleScope];
        name: string;
        iconIndex: number;
        time: ITime | ITimeSerialized;
        permissions?: IPermission[];
    }

    export interface IRoleSerialized extends IRole {
        time: ITime;
    }

    export interface IDefaultRole {
        scope: typeof ERoleScope[keyof typeof ERoleScope];
        name: string;
        iconIndex: number;
        options?: {
            roleId: string;
            permissions?: IPermission[];
        };
    }

    export interface IPermission {
        type: typeof EPermissionType[keyof typeof EPermissionType];
        mask: number;
    }

    interface IAbtractCreateInfo {
        contractId: string;
        scope: typeof ERoleScope[keyof typeof ERoleScope];
        name: string;
        iconIndex: number;
        roleId?: string;
        permissions?: IPermission[];
    }

    interface IAbtractDeleteInfo {
        contractId: string;
        roleId: string;
    }

    interface IAbstractGetInfo {
        contractId: string;
        roleId: string;
    }

    interface IAbstractUpdateInfo {
        contractId: string;
        roleId: string;
        name?: string;
        iconIndex?: number;
        permissions?: IPermission[];
    }

    export module Database {
        export interface ICreateInfo extends IAbtractCreateInfo {}
        export interface IDeleteInfo extends IAbtractDeleteInfo {}
        export interface IGetInfo extends IAbstractGetInfo {}
        export interface IUpdateInfo extends IAbstractUpdateInfo {}
    }
}
